import { Box, Typography } from '@material-ui/core';
import React from 'react';

export function FormSection({ title, children }: { title: string; children?: React.ReactNode }): React.ReactElement {
  return (
    <Box borderColor="grey.100" border={1} style={{ padding: '1rem', borderRadius: '4px', margin: '1rem' }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {children}
    </Box>
  );
}
